<template>
  <div class="pdf-loading">
    加载中...
  </div>
</template>

<script>

  export default {
    name: 'loading',
    data() {
      return {        
      }
    },    
    methods: {      
    }
  }
</script>

<style scoped>
  .pdf-loading {
    text-align: center;
    padding-top: 8px;
    background: url('../../assets/image/loadingGif1.gif' )  no-repeat 50% 70%;
    width: 10%;
    height: 10%;
    top: 45%;
    left: 45%;
    position: fixed;
    float: left;
    background-color: #ffffff;
    z-index: 777;
    border: 10px solid #fff;
    border-bottom: 15px solid #fff;
    -webkit-box-shadow: 3px 3px 3px #777;
    -moz-box-shadow: 3px 3px 3px #777;
    box-shadow: 3px 3px 3px #777;
  }
</style>



// WEBPACK FOOTER //
// src/components/Loading/loading.vue